<template>
  <div>
    <table-paginator
      :data="accountTransactions"
      @pagechange="$emit('pagechange', $event)"
    >
      <div class="row grid-table-heading mt-4 mb-0">
        <div class="col-md-6">Descrição</div>
        <div class="col-md-2 text-center">Método de pagamento</div>
        <div class="col-md-2 text-right">Valor</div>
        <div class="col-md-2 text-right pr-4">Saldo</div>
      </div>
      <hr class="mt-1" />
      <template v-for="row in accountTransactions.data">
        <div class="row grid-table-row pt-4" :key="row.id">
          <div class="col-md-6">
            <account-transaction-label :account-transaction="row" @openBillPaymentModal="$emit('openBillPaymentModal', $event)"/>
          </div>
          <div class="col-md-2 text-center">
            <payment-method-badge :payment-method="row.payment_method" />
          </div>
          <div class="col-md-2 text-right">
            <account-transaction-value-label
              :value="row.value"
              :status="row.status"
              :payment-method="row.payment_method"
            />
          </div>
          <div class="col-md-2 text-right">
            <div class="d-flex">
              <div class="flex-grow-1">
                <account-transaction-value-label
                  v-if="row.payment_method == 1"
                  :value="row.balance"
                  :status="row.status"
                  :payment-method="row.payment_method"
                />
                <span class="mr-2" v-else>-</span>
              </div>
              <div class="ml-2">
                <b-dropdown
                  variant="light"
                  right
                  size="sm"
                  toggle-class="text-decoration-none ml-3"
                  no-caret
                  :disabled="disableCancelButton(row)"
                >
                  <template v-slot:button-content>
                    <i class="fas fa-ellipsis-v text-muted" />
                  </template>
                  <b-dropdown-item v-if="$acl.can('accountTransactionCancel')"  @click.stop="$emit('cancel', row)">
                    <i class="fas fa-file-invoice" />
                    Cancelar
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </template>
    </table-paginator>
  </div>
</template>

<script>
import TablePaginator from "@/components/sections/TablePaginator";
import AccountTransactionLabel from "@/components/account/sections/AccountTransactionLabel.vue";
import AccountTransactionValueLabel from "@/components/account/sections/AccountTransactionValueLabel.vue";
import PaymentMethodBadge from "@/components/account/sections/PaymentMethodBadge.vue";

export default {
  components: {
    AccountTransactionLabel,
    AccountTransactionValueLabel,
    PaymentMethodBadge,
    TablePaginator,
  },

  props: {
    accountTransactions: {},
    accountResume: {},
  },

  computed: {
    closingBalance() {
      return this.$store.getters["drawer/closingBalance"];
    },

    openingBalance() {
      return this.$store.getters["drawer/openingBalance"];
    },
  },
  methods: {
    disableCancelButton(data) {
      if (data.status == "c") {
        return true;
      }

      if (data.payment_method != 1 && data.origin == "o") {
        return true;
      }
    },
  },
};
</script>

<style>
</style>